import { Flex, Skeleton, Text } from '@chakra-ui/react';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Placeholder for a PDF that is still being fetched or rendered: a white page
 * card shaped like the ones the viewer will paint, holding a spinner and pulsing
 * text lines. It is deliberately unframed so it can also stand in for the page
 * area inside `PdfViewer` without nesting a second border.
 */
const PdfLoader = ({ viewerHeight = '80vh' }: { viewerHeight?: string }) => (
  <Flex
    // Matches the height of the page area in PdfViewer.
    h={viewerHeight}
    bg="white"
    p={6}
    justifyContent="center"
  >
    <Flex
      bg="white"
      boxShadow="0 4px 14px rgba(0,0,0,0.15)"
      borderRadius="4px"
      width={{ base: '92%', md: '60%' }}
      height="full"
      p={10}
      flexDirection="column"
      gap={8}
    >
      <Flex alignItems="center" gap={3}>
        <FontAwesomeIcon icon={faSpinner} spin size="lg" />
        <Text textStyle="headingItem">Loading file...</Text>
      </Flex>

      {[4, 3].map((lineCount, group) => (
        <Flex key={group} flexDirection="column" gap={4}>
          {Array.from({ length: lineCount }, (_, line) => (
            <Skeleton
              key={line}
              height="12px"
              width={line === lineCount - 1 ? '64%' : '100%'}
            />
          ))}
        </Flex>
      ))}
    </Flex>
  </Flex>
);

export default PdfLoader;
